import { useState } from "react";
import { clientError } from "src/context/errors";
import { requestRegisPhoneNoType } from "src/services/authInterface";
import authService from "src/services/authService";
import { responseReducer } from "src/utils/responseReducer";

const useRequestRegisPhoneNo = () => {
  const resReducer = responseReducer<requestRegisPhoneNoType>();
  const [loading, setLoading] = useState(false);

  const requestRegisPhoneNo = async (brokerID: string, phoneNo: string) => {
    try {
      setLoading(true);
      const data = await authService.requestRegisPhoneNo(brokerID, phoneNo);
      setLoading(false);

      switch (data.__typename) {
        case "RequestRegisPhoneNo":
          return resReducer(undefined, data);
        case "Error":
          return resReducer(data);
        default:
          return resReducer(clientError.connectionWentWrong);
      }
    } catch {
      setLoading(false);
      return resReducer(clientError.somethingWentWrong);
    }
  };

  return {
    requestRegisPhoneNo,
    loading,
  };
};

export default useRequestRegisPhoneNo;
